'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Tooltip = require('@material-ui/core/Tooltip');
require('../ThemeProvider/ThemeProvider.js');
var colors = require('../ThemeProvider/colors.js');
require('../ThemeProvider/theme.js');
var ColorPickerMenu = require('./ColorPickerMenu.js');
var ColorPickerButton = require('./ColorPickerButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);

/** Input for selecting color values. */

var ColorPicker = _ref => {
  var {
    id,
    value = colors.colors.blueGrey[500],
    onChange: _onChange,
    label,
    colors: colors$1 = colors.colorsMain
  } = _ref;
  var [anchor, setAnchor] = React__default['default'].useState(null);

  var close = () => setAnchor(null);

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    "aria-label": label,
    style: {
      display: 'inline-flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(Tooltip__default['default'], {
    title: "Click to Change Color"
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(ColorPickerButton.ColorPickerButton, {
    color: value,
    onClick: event => setAnchor(event.currentTarget)
  })))), /*#__PURE__*/React__default['default'].createElement(ColorPickerMenu.ColorPickerMenu, {
    colors: colors$1,
    anchor: anchor,
    close: close,
    onChange: newValue => {
      close();

      _onChange(newValue);
    },
    value: value
  }));
};

ColorPickerButton.ColorPickerButton.propTypes = {
  /** If `true`, a check mark appears. */
  checked: index.bool,

  /** Color of the button. */
  color: index.string,

  /** Label of the button. */
  label: index.string,

  /**
   * Callback when button is clicked.
   */
  onClick: index.func
};
ColorPickerMenu.ColorPickerMenu.propTypes = {
  /** The current color value of the picker. */
  value: index.string,
  anchor: index.any,
  close: index.func,
  onChange: index.func.isRequired
};
ColorPicker.propTypes = {
  /** The id of the picker. */
  id: index.string,

  /** Label of the button. */
  label: index.string,

  /**
   * Callback when a color is selected.
   *
   * @param {object} event The source event from the callback.
   */
  onChange: index.func.isRequired,

  /** The current color value of the picker. */
  value: index.string
};

exports.ColorPickerMenu = ColorPickerMenu.ColorPickerMenu;
exports.ColorPickerButton = ColorPickerButton.ColorPickerButton;
exports.ColorPicker = ColorPicker;
exports.default = ColorPicker;
